export default {
    getUserProfile({ commit }) {
      this.$api.getUserProfile().then((data) => {
        const completeData = {
          user: data
        }
        commit('setUserProfileData', completeData)
      })
    }
  }